import React from 'react';
import PropTypes from 'prop-types';
import {findDOMNode} from 'react-dom';
import FontAwesome from 'react-fontawesome';
import ItemColor from './item_color';

import ModalDropdown from './modal_dropdown';

export default class SelectionButton extends React.Component {
  static propTypes = {
    selectionList: PropTypes.array.isRequired,
    option: PropTypes.object.isRequired,
    onChange: PropTypes.func,
    unitMultiplier: PropTypes.number,
    isOnlyOption: PropTypes.bool,
    hideColor: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.getComponentDimensions = this.getComponentDimensions.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputBlur = this.handleInputBlur.bind(this);
    this.handleInputKeyDown = this.handleInputKeyDown.bind(this);
    this.onWindowResize = this.onWindowResize.bind(this);

    this.manualTextInput = null;

    let currentSelection = this.props.selectionList.find(selection => this.props.option._option.token === selection.option);
    let value = currentSelection ? currentSelection.batches * this.props.unitMultiplier : 0;

    this.state = {
      opened: false,
      manualInput: false,
      manualInputValue: 0,
      dimensions: null,
      value: value
    };
  }

  componentDidMount() {
    this.setState({
      dimensions: this.getComponentDimensions()
    });

    window.addEventListener('resize', this.onWindowResize, false);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== undefined && nextProps.value !== this.state.value) {
      this.setState({ value: nextProps.value });
    }
  }

  componentDidUpdate() {
    if (this.manualTextInput) this.manualTextInput.focus();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onWindowResize, false);
  }

  onWindowResize() {
    this.setState({
      dimensions: this.getComponentDimensions()
    });
  }

  getComponentDimensions() {
    let dom = findDOMNode(this);
    let box = dom.getBoundingClientRect();
    let dimensions = {};
    ['top', 'right', 'bottom', 'left', 'width', 'height'].forEach(key => {
      dimensions[key] = box[key];
    });

    return dimensions;
  }

  toggle() {
    if (this.state.manualInput) return;
    this.setState({
      opened: !this.state.opened,
      dimensions: this.getComponentDimensions()
    });
  }

  onChange(value) {
    let payload = {
      opened: false
    };
    if (value === '+') {
      payload.manualInput = true;
      let actualValue = this.props.unitMultiplier * 10;
      if (this.state.value > actualValue) actualValue = this.state.value;
      payload.manualInputValue = actualValue;
    }
    this.setState(payload);

    if (value !== '+') {
      this.props.onChange(value);
    }
  }

  onCancel() {
    this.setState({ opened: false });
  }

  handleInputChange(event) {
    let value = event.target.value;
    let fixedValue = '';

    let i;
    for (i = 0; i < value.length; i++) {
      if (value[i] >= '0' && value[i] <= '9') {
        fixedValue += value[i];
      }
    }
    this.setState({
      manualInputValue: fixedValue
    });
  }

  handleInputBlur(event) {
    event.preventDefault();

    let actualValue = 0;
    let currentValue = this.props.unitMultiplier;
    while (this.state.manualInputValue >= currentValue) {
      actualValue = currentValue;
      currentValue += this.props.unitMultiplier;
    }

    if (actualValue === 0 && this.props.isOnlyOption) actualValue = this.props.unitMultiplier;

    this.setState({
      manualInput: false,
      value: actualValue
    });

    this.props.onChange(actualValue);
  }

  handleInputKeyDown(event) {
    let key = event.keyCode || event.charCode || 0;

    // Escape key
    if (key === 27) {
      event.preventDefault();
      this.setState({
        manualInput: false,
        manualInputValue: this.state.value
      });
      return;
    }

    // Return key
    if (key === 13) {
      this.handleInputBlur(event);
      return;
    }
  }

  generateOptionList() {
    let optionList = {};
    let iStart = 0;
    if (this.props.isOnlyOption) iStart = 1;
    for (let i = iStart; i < 10; i++) {
      optionList[i * this.props.unitMultiplier] = i * this.props.unitMultiplier;
    }

    let maxValue = 10 * this.props.unitMultiplier;
    if (this.state.value > maxValue) maxValue = this.state.value;

    optionList['+'] = `${maxValue}+`;

    return optionList;
  }

  render() {
    let currentSelection = this.props.selectionList.find(selection => this.props.option._option.token === selection.option);
    let actualQuantity = currentSelection ? currentSelection.batches * this.props.unitMultiplier : 0;
    let color = null;

    if (!this.props.hideColor) {
      color = this.props.option.Color || this.props.option.color || this.props.option.Colors || this.props.option.colors || null;
    }

    let dropDown = null;
    let classNames = [ 'selection-item' ];

    if (this.state.opened) {
      dropDown =
        <ModalDropdown
          value={actualQuantity}
          options={this.generateOptionList()}
          onChange={this.onChange}
          onCancel={this.onCancel}
        />;
    }

    if (this.state.manualInput) {
      actualQuantity = <input
        value={this.state.manualInputValue}
        ref={input => this.manualTextInput = input}
        onChange={this.handleInputChange}
        onBlur={this.handleInputBlur}
        onKeyDown={this.handleInputKeyDown}
      />;
      classNames.push('manual-input');
    }

    if (this.props.className) classNames.push(this.props.className);
    if (!color) classNames.push('no-color');

    if (this.props.option._text.toLowerCase() === 'default') {
      classNames.push('default-value');
      return (
        <div className={classNames.join(' ')} onClick={this.toggle}>
          <span className="quantity full-width">
            {actualQuantity}
          </span>
          <span className="quantity-chevron"><FontAwesome name="angle-down"/></span>
          {dropDown}
        </div>
      );
    }

    return (
      <div className={classNames.join(' ')} onClick={this.toggle}>
        <ItemColor color={color}/>
        <span className="name">{this.props.option._text}</span>
        <span className="quantity">
          {actualQuantity}
        </span>
        <span className="quantity-chevron"><FontAwesome name="angle-down"/></span>
        {dropDown}
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/ProductModal/selection_button.js
 **/